import React, { useState } from 'react';
import { Nullable } from 'global';
import { Button, Stack, Typography } from '@mui/material';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { Preset } from './Preset';
import { PresetFilter, PresetFilterActions, PresetId } from '../types';

interface Props<Value> {
  isLoading?: boolean;
  actionsLoading?: boolean;
  list: PresetFilter<Value>[];
  actions: PresetFilterActions;
}

export const ListOfPresets = <Value,>({
  actions,
  list = [],
  isLoading = false,
  actionsLoading = false,
}: Props<Value>) => {
  const [activePreset, setActivePreset] = useState<Nullable<PresetId>>(
    () => list.find(({ isSelected }) => isSelected)?.id ?? null
  );

  return (
    <Stack gap="0.5rem" flexWrap="wrap" direction="row">
      <RenderWithFallback isLoading={isLoading} fallBack={<>Loading...</>}>
        <RenderWithCondition
          condition={!!list.length}
          fallBack={
            <>
              {typeof actions.onCreate === 'function' ? (
                <Button size="small" onClick={actions.onCreate}>
                  Create
                </Button>
              ) : (
                <Typography>List empty</Typography>
              )}
            </>
          }
        >
          {list.map(preset => (
            <Preset<Value>
              key={preset.id}
              actionsLoading={actionsLoading}
              filter={{ ...preset, isSelected: activePreset === preset.id }}
              actions={{
                ...actions,
                onSelect: async presetId => {
                  setActivePreset(presetId);
                  await actions.onSelect(presetId);
                },
              }}
            />
          ))}
        </RenderWithCondition>
      </RenderWithFallback>
    </Stack>
  );
};
